import * as Immutable from 'immutable';

export interface StoreIntegrationPayload {
	slug: string
  name: string
  disabled: boolean
  legacy: boolean
}

export interface IStoreIntegrationStore {
	slug: string
  name: string
  disabled: boolean
  legacy: boolean
}

const defaultStoreIntegrationStore = Immutable.Record<IStoreIntegrationStore>({
	slug: '',
  name: '',
  disabled: false,
  legacy: false,
});

export default class StoreIntegrationStore extends defaultStoreIntegrationStore implements IStoreIntegrationStore {}
